(function () {
    var videoPlayers = {
        initStarted: false,
        windowLoaded: false,
        collected: 0,
        collection: [],
        iframes: null,
        isMobile: false,
        scrollBinded: false,
        checkingScroll: {'status': 'paused', 'redo': false},
        checkingInit: {'status': 'paused', 'redo': false},
        parameters: function (name) {
            var result = null,
                    tmp = [];
            location.search
                    .substr(1)
                    .split("&")
                    .forEach(function (item) {
                        tmp = item.split("=");
                        if (tmp[0] === name)
                            result = decodeURIComponent(tmp[1]);
                    });
            return result;
        },
        log: function (text) {
            if (videoPlayers.parameters('test') !== 'true')a
            {
                return;
            }

            var logger = document.getElementById('videoplayer_log');
            if (!logger)
            {
                var logger = document.createElement("div");
                logger.setAttribute('style', 'position: fixed;top:0;left:0;right:0;height:50px;background-color:black;color:white;opacity:0.7');
                logger.id = 'videoplayer_log';
                document.body.appendChild(logger);
            }

            logger.innerHTML = text;
        },
        getOffset: function (el) {
            var div = window.document.querySelector('iframe[data-src]');
            var rect = el.getBoundingClientRect();
            x = rect.left;
            y = rect.top; // how far from the top of the view port
            w = rect.width;

            return rect;
        },

        // LazyLoad on Scroll
        lazyLoadScroll: function () {
            if (videoPlayers.checkingScroll['status'] === 'running')
            {
                videoPlayers.checkingScroll['redo'] = true;
                return;
            }

            if (videoPlayers.collected === 0)
            {
                window.removeEventListener('scroll', videoPlayers.lazyLoadScroll);
                videoPlayers.scrollBinded = false;
                return;
            }

            var scroll = {
                'top': (window.pageXOffset !== undefined) ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop,
                'height': window.innerHeight
            };

            videoPlayers.checkingScroll['status'] = 'running';

            for (var i in videoPlayers.collection)
            {
                if (!videoPlayers.collection[i])
                    continue;

                var videoOffset = videoPlayers.getOffset(videoPlayers.collection[i]);
                videoPlayers.log('top: ' + ((videoOffset.top - scroll.height) - 150) + ' / bottom: ' + (videoOffset.bottom + 150));

                if ((videoOffset.top - scroll.height) - 150 <= 0 && videoOffset.bottom + 150 >= 0)
                {

                    videoPlayers.collection[i].style.opacity = 0.6;
                    videoPlayers.collection[i].addEventListener('load', function() {
                        this.style.removeProperty('opacity');
                    });

                    videoPlayers.collection[i].removeAttribute('src');
                    videoPlayers.collection[i].removeAttribute('srcdoc');
                    videoPlayers.collection[i].src = videoPlayers.collection[i].dataset.src;

                    videoPlayers.collection[i] = null;

                    videoPlayers.collected--;
                }
            }

            videoPlayers.collection = videoPlayers.collection.filter(function (v) {
                return v !== null;
            });

            videoPlayers.checkingScroll['status'] = 'paused';

            if (videoPlayers.checkingScroll['redo'] === true)
            {
                videoPlayers.checkingScroll['redo'] = false;
                setTimeout(videoPlayers.lazyLoadScroll, 150);
            }
        },

        // Loading video
        lazyLoadVideoImage: function () {
            var $this = this;
            $this.removeEventListener('click', videoPlayers.lazyLoadVideoImage);

            var iframe = document.createElement("iframe");
            iframe.setAttribute("src", $this.dataset.video + ($this.dataset.video.indexOf('?') ? '&' : '?') + 'autoplay=1');
            iframe.setAttribute("frameborder", 0);
            iframe.setAttribute("allow", "autoplay; encrypted-media");
            iframe.setAttribute("allowfullscreen", "true");
            iframe.style.width = $this.offsetWidth + "px";
            iframe.style.height = $this.offsetHeight + "px";
            iframe.style.position = "absolute";
            iframe.style['z-index'] = "-1";

            var attributes = $this.attributes;

            for (var att, c = 0, n = attributes.length; c < n; c++) {
                att = attributes[c];
                if (att.nodeName === 'src' || att.nodeName === 'data-video')
                    continue;
                iframe.setAttribute(att.nodeName, att.nodeValue);
            }

            this.style.opacity = 0.6;

            iframe.addEventListener('load', function () {
                this.style.removeProperty('position');
                this.style.removeProperty('z-index');

                if ($this.closest(".video-player"))
                {
                    $this.closest(".video-player").classList.remove("video-player");
                }

                $this.remove();
            });

            this.parentNode.insertBefore(iframe, this);
        },

        // Initialize lazyLoadVideo on Source
        initSource: function () {
            if (videoPlayers.checkingInit['status'] === 'running')
            {
                videoPlayers.checkingInit['redo'] = true;
                return;
            }

            videoPlayers.checkingInit['status'] = 'running';
            var sources = window.document.querySelectorAll('img[data-video]'), reload = false;

            sources.forEach(function (source) {
                if (videoPlayers.collection.indexOf(source) >= 0)
                {
                    return;
                }

                var placeholder = source;

                if (videoPlayers.isMobile === true)
                {
                    if (source.closest(".video-player"))
                    {
                        source.closest(".video-player").classList.remove("video-player");
                    }

                    if (source.dataset.mobileVideo !== undefined)
                    {
                        source.dataset.video = source.dataset.mobileVideo;
                    }

                    if (source.offsetWidth === 0 || source.offsetHeight === 0)
                    {
                        const observer = new IntersectionObserver((entries, observer) => {
                            entries.forEach(entry => {
                                if (entry.target.offsetWidth > 0 && entry.target.offsetHeight > 0)
                                {
                                    var placeholder = document.createElement("iframe"),
                                            $this = entry.target;

                                    placeholder.setAttribute("data-src", $this.dataset.video);
                                    placeholder.setAttribute("loading", "lazy");
                                    placeholder.setAttribute("frameborder", 0);
                                    placeholder.setAttribute("allow", "autoplay; encrypted-media");
                                    placeholder.setAttribute("allowfullscreen", "true");
                                    placeholder.style.width = $this.offsetWidth + "px";
                                    placeholder.style.height = $this.offsetHeight + "px";

                                    if ($this.closest('picture'))
                                    {
                                        $this.closest('picture').replaceWith(placeholder);
                                    } else {
                                        $this.replaceWith(placeholder);
                                    }

                                    videoPlayers.collection.push(placeholder);

                                    if (videoPlayers.scrollBinded === false)
                                    {
                                        videoPlayers.scrollBinded = true;
                                        videoPlayers.collected = videoPlayers.collection.length;

                                        window.addEventListener('scroll', videoPlayers.lazyLoadScroll);

                                        videoPlayers.lazyLoadScroll();
                                    }
                                }
                            });
                        }, {
                            rootMargin: '0px',
                            threshold: 1.0
                        });

                        observer.observe(source);
                    } else {
                        var placeholder = document.createElement("iframe");
                        placeholder.setAttribute("data-src", source.dataset.video);
                        placeholder.setAttribute("loading", "lazy");
                        placeholder.setAttribute("frameborder", 0);
                        placeholder.setAttribute("allow", "autoplay; encrypted-media");
                        placeholder.setAttribute("allowfullscreen", "true");
                        placeholder.style.width = source.offsetWidth + "px";
                        placeholder.style.height = source.offsetHeight + "px";

                        if (source.closest('picture'))
                        {
                            source.closest('picture').replaceWith(placeholder);
                        } else {
                            source.replaceWith(placeholder);
                        }

                        videoPlayers.collection.push(placeholder);
                    }
                } else {
                    source.addEventListener('click', videoPlayers.lazyLoadVideoImage);
                }
            });

            if (videoPlayers.collection.length > 0 && videoPlayers.isMobile === true)
            {
                if (videoPlayers.scrollBinded === false)
                {
                    videoPlayers.collected = sources.length;
                    videoPlayers.scrollBinded = true;
                    window.addEventListener('scroll', videoPlayers.lazyLoadScroll);
                }
            }

            videoPlayers.checkingInit['status'] = 'paused';

            if (videoPlayers.checkingInit['redo'] === true)
            {
                videoPlayers.checkingInit['redo'] = false;
                setTimeout(videoPlayers.initSource, 150);
            } else {
                if (videoPlayers.windowLoaded === false)
                {
                    setTimeout(videoPlayers.initSource, 150);
                } else {
                    videoPlayers.lazyLoadScroll();
                }
            }
        },

        // Initialize lazyLoadVideo
        init: function () {
            videoPlayers.initStarted = true;

            window.addEventListener('DOMContentLoaded', function () {
                videoPlayers.windowLoaded = true;
            });

            // device detection
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                videoPlayers.isMobile = true;
            }

            videoPlayers.initSource();

            setTimeout(function () {
                videoPlayers.windowLoaded = true;
            }, 3000);
        }
    };

    if(['complete','interactive'].includes(document.readyState))
    {
        videoPlayers.init();
    } else {
        window.addEventListener('DOMContentLoaded', function () {
            videoPlayers.init();
        });
    }

    setTimeout(function () {
        videoPlayers.initStarted || videoPlayers.init();
    }, 3000);
})();